export enum AppErrorEnumeration {
  ACCOUNT_CHECK_IFRAME_FETCH_URL_ERROR = 'ACCOUNT_CHECK_IFRAME_FETCH_URL_ERROR',
  ACCOUNT_CHECK_IFRAME_LOAD_ERROR = 'OPENBANKING_IFRAME_LOAD_ERROR',
  ACCOUNT_CHECK_INVALID_TINK_ERROR = 'ACCOUNT_CHECK_INVALID_TINK_ERROR',
  AUTH_DATA_CLEAN_FAILED = 'AUTH_DATA_CLEAN_FAILED',
  BACK_STATE_KYC_FAILED = 'BACK_STATE_KYC_FAILED',
  BACKGROUND_REFRESH_ERROR = 'BACKGROUND_REFRESH_ERROR',
  BACK_STATE_PROOF_OF_INCOME_FAILED = 'BACK_STATE_PROOF_OF_INCOME_FAILED',
  BIZUM_WS_ERROR = 'BIZUM_WS_ERROR',
  BIZUM_WS_STATUS_REJECTED = 'BIZUM_WS_STATUS_REJECTED',
  BIZUM_VERIFICATION_URL_GENERATION_FAILED = 'BIZUM_VERIFICATION_URL_GENERATION_FAILED',
  CHECKOUT_NO_INFO = 'CHECKOUT_NO_INFO',
  COMPLETE_ACCOUNT_CHECK_FAILED = 'COMPLETE_ACCOUNT_CHECK_FAILED',
  COMPLETE_OPENBANKING_FAILED = 'COMPLETE_OPENBANKING_FAILED',
  CONTRACTUAL_SCREEN_DETAILS_FAILED = 'CONTRACTUAL_SCREEN_DETAILS_FAILED',
  AUTH_WEALTH_REFRESH_TOKEN_FAILED = 'AUTH_WEALTH_REFRESH_TOKEN_FAILED',
  FETCH_OCR_DATA_FAILED = 'FETCH_OCR_DATA_FAILED',
  FETCH_STEP_DETAILS_FAILED = 'FETCH_STEP_DETAILS_FAILED',
  GENERATE_OTP_FAILED = 'GENERATE_OTP_FAILED',
  GET_ID_VALIDATION_DETAILS_FAILED = 'GET_ID_VALIDATION_DETAILS_FAILED',
  GET_IDENTIFICATION_DETAILS_FAILED = 'GET_IDENTIFICATION_DETAILS_FAILED',
  GET_INCOME_DETAILS_FAILED = 'GET_INCOME_DETAILS_FAILED',
  GET_OTP_INFO_FAILED = 'GET_OTP_INFO_FAILED',
  GET_PAYMENT_DETAILS_FAILED = 'GET_PAYMENT_DETAILS_FAILED',
  GET_SIGNATURE_DETAILS_FAILED = 'GET_SIGNATURE_DETAILS_FAILED',
  GET_VERIFICATION_OPTIONS_FAILED = 'GET_VERIFICATION_OPTIONS_FAILED',
  OPERATIVE_TOO_MANY_REQUESTS = 'OPERATIVE_TOO_MANY_REQUESTS',
  EXPRESS_ID_URL_GENERATION_FAILED = 'EXPRESS_ID_URL_GENERATION_FAILED',
  INITIALIZE_PROOF_OF_INCOME_FAILED = 'INITIALIZE_PROOF_OF_INCOME_FAILED',
  IFRAME_LOAD_BLOCKED_PROCESS_ERROR = 'IFRAME_LOAD_BLOCKED_PROCESS_ERROR',
  KYC_INITIALIZE_FAILED = 'KYC_INITIALIZE_FAILED',
  KYC_METHOD_WS_STATUS_REJECTED = 'METHOD_WS_STATUS_REJECTED',
  KYC_BIZUM_WS_STATUS_REJECTED = 'KYC_BIZUM_WS_STATUS_REJECTED',
  KYC_BIZUM_POLLING_ERROR = 'KYC_BIZUM_POLLING_ERROR',
  KYC_BIZUM_TIMER_EXPIRED = 'KYC_BIZUM_TIMER_EXPIRED',
  KYC_METHOD_POLLING_ERROR = 'KYC_METHOD_POLLING_ERROR',
  NO_AUTH_DATA_FROM_QUERY_TOKEN = 'NO_AUTH_DATA_FROM_QUERY_TOKEN',
  NO_LOGGED_OR_QUERY_TOKEN = 'NO_LOGGED_OR_QUERY_TOKEN',
  NO_REDIRECTED_FORCED_AND_STILL_STAY = 'NO_REDIRECTED_FORCED_AND_STILL_STAY',
  NO_VALIDATION_ID_ERROR = 'NO_VALIDATION_ID_ERROR',
  ONBOARDING_TIME_LIMIT_REACHED = 'ONBOARDING_TIME_LIMIT_REACHED',
  OPENBANKING_IFRAME_LOAD_ERROR = 'OPENBANKING_IFRAME_LOAD_ERROR',
  OPENBANKING_IFRAME_FETCH_URL_ERROR = 'OPENBANKING_IFRAME_FETCH_URL_ERROR',
  OPENBANKING_INVALID_TINK_ERROR = 'OPENBANKING_INVALID_TINK_ERROR',
  PAYMENT_INITIALIZE_FAILED = 'PAYMENT_INITIALIZE_FAILED',
  PAYMENT_LOAD_STRIPE_SCRIPT_ERROR = 'PAYMENT_LOAD_STRIPE_SCRIPT_ERROR',
  PAYMENT_CARD_ERROR = 'PAYMENT_CARD_ERROR',
  PAYMENT_MAX_ATTEMPTS = 'PAYMENT_MAX_ATTEMPTS',
  PDF_VIEWER_ERROR = 'PDF_VIEWER_ERROR',
  PRECONTRACT_FAILED_NO_CONSENTS = 'PRECONTRACT_FAILED_NO_CONSENTS',
  PRECONTRACT_SCREEN_DETAILS_FAILED = 'PRECONTRACT_SCREEN_DETAILS_FAILED',
  PRECONTRACT_GIL_RISK_ERROR = 'PRECONTRACT_GIL_RISK_ERROR',
  PROOF_OF_INCOME_WS_REJECTED = 'PROOF_OF_INCOME_WS_REJECTED',
  REFRESH_TOKEN_REMOVED = 'REFRESH_TOKEN_REMOVED',
  REDIRECT_DATA_FAILED = 'REDIRECT_DATA_FAILED',
  SAVE_CONTRACTUAL_FAILED = 'SAVE_CONTRACTUAL_FAILED',
  SAVE_DIFFERENT_DATA_FAILED = 'SAVE_DIFFERENT_DATA_FAILED',
  SAVE_PAYMENT_METHOD_FAILED = 'SAVE_PAYMENT_METHOD_FAILED',
  SAVE_PRECONTRACT_FAILED_WITH_CONSENTS = 'SAVE_PRECONTRACT_FAILED_WITH_CONSENTS',
  STATE_FAILED = 'STATE_FAILED',
  STRIPE_CHECK_PAYMENT_CARD_FAILED = 'STRIPE_CHECK_PAYMENT_CARD_FAILED',
  STRIPE_CONFIRM_PAYMENT_FAILED = 'STRIPE_CONFIRM_PAYMENT_FAILED',
  STRIPE_CREATE_PAYMENT_METHOD_FAILED = 'STRIPE_CREATE_PAYMENT_METHOD_FAILED',
  STRIPE_PAYMENT_METHOD_WITHOUT_CARD = 'STRIPE_PAYMENT_METHOD_WITHOUT_CARD',
  STRIPE_SUBMIT_ELEMENTS_FAILED = 'STRIPE_SUBMIT_ELEMENTS_FAILED',
  STRIPE_PAYMENT_ELEMENT_LOAD_ERROR = 'STRIPE_PAYMENT_ELEMENT_LOAD_ERROR',
  TMX_LOADED_FAILED_ERROR = 'TMX_LOADED_FAILED_ERROR',
  TOKEN_REMOVED = 'TOKEN_REMOVED',
  TGSS_IFRAME_FETCH_URL_ERROR = 'TGSS_IFRAME_FETCH_URL_ERROR',
  TGSS_IFRAME_LOAD_ERROR = 'TGSS_IFRAME_LOAD_ERROR',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
  UPLOAD_ID_IFRAME_FETCH_URL_ERROR = 'UPLOAD_ID_IFRAME_FETCH_URL_ERROR',
  UPLOAD_ID_IFRAME_LOAD_ERROR = 'UPLOAD_ID_IFRAME_LOAD_ERROR',
  UPLOAD_ID_VERIFICATION_WS_REJECTED = 'VERIFICATION_WS_REJECTED',
  UPLOAD_ID_POLLING_WRONG_STATE = 'UPLOAD_ID_POLLING_WRONG_STATE',
  UPLOAD_ID_ERROR_NO_MAPPED = 'UPLOAD_ID_ERROR_NO_MAPPED',
  UPLOAD_ID_CREATE_VALIDATION_ID_FAILED = 'UPLOAD_ID_CREATE_VALIDATION_ID_FAILED',
  VERIDAS_ERROR_EVENT = 'VERIDAS_ERROR_EVENT',
  VERIDAS_CAMERA_FAILURE_EVENT = 'VERIDAS_CAMERA_FAILURE_EVENT',
  VERIDAS_VIDEOCALL_ERROR_EVENT = 'VERIDAS_VIDEOCALL_ERROR_EVENT',
  VIDEOCALL_IFRAME_FETCH_URL_ERROR = 'VIDEOCALL_IFRAME_FETCH_URL_ERROR',
  VIDEOCALL_IFRAME_LOAD_ERROR = 'VIDEOCALL_IFRAME_LOAD_ERROR',
  VERIFY_OTP_FAILED = 'VERIFY_OTP_FAILED',
  WS_BIZUM_TIMEOUT = 'WS_BIZUM_TIMEOUT',
  WS_PAYMENT_TIMEOUT = 'WS_PAYMENT_TIMEOUT',
  WS_TGSS_TIMEOUT = 'WS_TGSS_TIMEOUT',
  WS_VERIDAS_TIMEOUT = 'WS_VERIDAS_TIMEOUT',
  WS_VIDEOCALL_TIMEOUT = 'WS_VIDEOCALL_TIMEOUT',
  WS_TIME_MAX_ALIVE_REACHED = 'WS_TIME_MAX_ALIVE_REACHED',
  UPLOAD_DOCUMENT_VERIFICATION_REJECTED = 'UPLOAD_DOCUMENT_VERIFICATION_REJECTED',
  UPLOAD_DOCUMENT_CONTINUE_ERROR = 'UPLOAD_DOCUMENT_CONTINUE_ERROR',
  UPLOAD_ID_SELFIE_REQUEST_URI_ERROR = 'UPLOAD_ID_SELFIE_REQUEST_URI_ERROR',
  UPLOAD_ID_SELFIE_UPLOAD_FILE_ERROR = 'UPLOAD_ID_SELFIE_UPLOAD_FILE_ERROR',
  UPLOAD_ID_SELFIE_UPLOAD_SELFIE_ERROR = 'UPLOAD_ID_SELFIE_UPLOAD_SELFIE_ERROR',
  UPLOAD_ID_SELFIE_SDK_ERROR_EVENT = 'UPLOAD_ID_SELFIE_SDK_ERROR_EVENT',
  UPLOAD_ID_SELFIE_CONSENT_ERROR = 'UPLOAD_ID_SELFIE_CONSENT_ERROR',
  UPLOAD_ID_BIZUM_TIMER_EXPIRED = 'UPLOAD_ID_BIZUM_TIMER_EXPIRED',
  UPLOAD_ID_BIZUM_BACK_STATE_FAILED = 'UPLOAD_ID_BIZUM_BACK_STATE_FAILED',
  UPLOAD_ID_BIZUM_BUSINESS_PROCESS_FAILED = 'UPLOAD_ID_BIZUM_BUSINESS_PROCESS_FAILED',
  UPLOAD_ID_BIZUM_POLLING_ERROR = 'UPLOAD_ID_BIZUM_POLLING_ERROR',
  UPLOAD_ID_BIZUM_REJECTED = 'UPLOAD_ID_BIZUM_REJECTED',
}
